export default __webpack_public_path__ + "static/media/nyan-cat.ea2aba64.png";